<div class="admin-rm-wrapper">
  <div class="header-section">
    <div class="header-title">
      <span class="badge-tag">CONCIERGE CRM ADMINISTRATION</span>
      <h2>Relationship Managers Management</h2>
      <p>Configure dedicated Relationship Managers (`RM`), monitor active client capacities, and manage manual reassignments for Express Plan subscribers.</p>
    </div>
    <div class="header-actions">
      <button class="btn-create-rm" (click)="openCreateModal()">
        <i class="bi bi-person-plus-fill"></i> Create New RM Account
      </button>
    </div>
  </div>

  <!-- Tabs Navigation -->
  <div class="tabs-bar">
    <button class="tab-btn" [ngClass]="{'active': activeTab === 'managers'}" (click)="activeTab = 'managers'">
      <i class="bi bi-people-fill"></i> Relationship Managers ({{ rms.length }})
    </button>
    <button class="tab-btn" [ngClass]="{'active': activeTab === 'subscribers'}" (click)="activeTab = 'subscribers'">
      <i class="bi bi-stars"></i> Express Subscribers & Assignments ({{ subscribers.length }})
    </button>
  </div>

  <div *ngIf="loading" class="loading-state">
    <div class="spinner-border" style="color: var(--color-primary, #B01E3E);" role="status"></div>
    <p class="mt-2">Loading Concierge CRM records...</p>
  </div>

  <!-- Tab 1: RM Accounts List -->
  <div *ngIf="!loading && activeTab === 'managers'" class="tab-content-area">
    <div class="table-responsive" *ngIf="rms.length > 0">
      <table class="rm-table">
        <thead>
          <tr>
            <th>Relationship Manager</th>
            <th>Contact Details</th>
            <th>Workload & Capacity</th>
            <th>Status</th>
            <th>Performance Counters</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rm of rms">
            <td>
              <div class="rm-cell">
                <div class="avatar">{{ rm.name.charAt(0) }}</div>
                <div class="meta">
                  <span class="name">{{ rm.name }}</span>
                  <span class="emp-id">Emp ID: {{ rm.employee_id }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="contact-cell">
                <span><i class="bi bi-envelope"></i> {{ rm.email }}</span>
                <span><i class="bi bi-telephone"></i> {{ rm.phone }}</span>
              </div>
            </td>
            <td>
              <div class="workload-cell">
                <div class="progress-wrap">
                  <div class="bar" [style.width.%]="(rm.current_assigned_clients / rm.max_client_capacity) * 100"></div>
                </div>
                <span class="cap-text"><strong>{{ rm.current_assigned_clients }}</strong> / {{ rm.max_client_capacity }} Active Clients</span>
              </div>
            </td>
            <td>
              <span class="status-pill" [ngClass]="rm.status === 'Active' ? 'active-pill' : 'inactive-pill'">
                {{ rm.status }}
              </span>
            </td>
            <td>
              <div class="perf-cell">
                <span><i class="bi bi-heart-fill" style="color: var(--color-primary, #B01E3E);"></i> {{ rm.performance?.completed_marriages || 0 }} Marriages</span>
              </div>
            </td>
            <td>
              <div class="action-btn-group">
                <button class="btn-action edit" (click)="openEditModal(rm)" title="Edit Details"><i class="bi bi-pencil-square"></i></button>
                <button class="btn-action status" (click)="toggleRmStatus(rm)" [title]="rm.status === 'Active' ? 'Disable RM' : 'Activate RM'">
                  <i class="bi" [ngClass]="rm.status === 'Active' ? 'bi-slash-circle text-danger' : 'bi-check-circle text-success'"></i>
                </button>
                <button class="btn-action pwd" (click)="resetRmPassword(rm)" title="Reset Password"><i class="bi bi-key-fill" style="color: #d97706;"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="rms.length === 0" class="empty-state">
      <i class="bi bi-people"></i>
      <h3>No Relationship Managers Found</h3>
      <p>Click the button above to create the very first Concierge Relationship Manager account.</p>
    </div>
  </div>

  <!-- Tab 2: Express Subscribers & Assignment Management -->
  <div *ngIf="!loading && activeTab === 'subscribers'" class="tab-content-area">
    <div class="table-responsive" *ngIf="subscribers.length > 0">
      <table class="rm-table">
        <thead>
          <tr>
            <th>Express Subscriber</th>
            <th>Contact details</th>
            <th>Membership Plan</th>
            <th>Current Stage</th>
            <th>Assigned RM Status</th>
            <th>Reassign Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sub of subscribers">
            <td>
              <div class="rm-cell">
                <div class="avatar">{{ sub.name.charAt(0) }}</div>
                <div class="meta">
                  <span class="name">{{ sub.name }}</span>
                  <span class="emp-id">#{{ sub._id?.toString()?.slice(-6)?.toUpperCase() }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="contact-cell">
                <span><i class="bi bi-telephone"></i> {{ sub.phone }}</span>
                <span><i class="bi bi-envelope"></i> {{ sub.email }}</span>
              </div>
            </td>
            <td>
              <span class="plan-pill"><i class="bi bi-stars"></i> {{ sub.current_plan }}</span>
            </td>
            <td>
              <span class="stage-badge" style="font-weight: 600; color: var(--color-on-surface, #2d2d2d);">{{ sub.rm_stage }}</span>
            </td>
            <td>
              <div *ngIf="sub.assigned_rm" class="assigned-rm-box">
                <span class="rm-name">{{ sub.assigned_rm.name }} ({{ sub.assigned_rm.employee_id }})</span>
                <span class="rm-status" [ngClass]="sub.assigned_rm.status === 'Active' ? 'text-success' : 'text-danger'">{{ sub.assigned_rm.status }}</span>
              </div>
              <span *ngIf="!sub.assigned_rm" class="unassigned-badge">Unassigned</span>
            </td>
            <td>
              <button class="btn-reassign" (click)="openReassignModal(sub)">
                <i class="bi bi-arrow-left-right"></i> Assign / Switch RM
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="subscribers.length === 0" class="empty-state">
      <i class="bi bi-stars"></i>
      <h3>No Express Subscribers Found</h3>
      <p>When users purchase the Express Concierge plan (`EXPRESS`), they will appear here with automatic lowest-workload assignment.</p>
    </div>
  </div>
</div>

<!-- Create Modal -->
<div class="modal-backdrop-custom" *ngIf="showCreateModal" (click)="closeCreateModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4><i class="bi bi-person-plus" style="color: var(--color-primary, #B01E3E);"></i> Create Relationship Manager Account</h4>
      <button class="btn-close-modal" (click)="closeCreateModal()"><i class="bi bi-x-lg"></i></button>
    </div>

    <div *ngIf="createError" class="alert alert-danger mx-3 mt-3 mb-0">{{ createError }}</div>

    <div class="modal-body">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Full Name *</label>
          <input type="text" [(ngModel)]="newRm.name" placeholder="e.g. Priya Sharma" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Employee ID *</label>
          <input type="text" [(ngModel)]="newRm.employee_id" placeholder="e.g. RM-101" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Official Email *</label>
          <input type="email" [(ngModel)]="newRm.email" placeholder="priya.rm@weddingly.com" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Mobile Phone *</label>
          <input type="text" [(ngModel)]="newRm.phone" placeholder="+91 9876543210" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Initial Security Password *</label>
          <input type="password" [(ngModel)]="newRm.password" placeholder="Min 6 characters" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Maximum Client Capacity *</label>
          <input type="number" [(ngModel)]="newRm.max_client_capacity" placeholder="50" class="form-control" />
        </div>
        <div class="col-12">
          <label class="form-label">Internal Notes / Specialization</label>
          <textarea [(ngModel)]="newRm.notes" placeholder="e.g. Specialized in South Indian communities..." rows="2" class="form-control"></textarea>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeCreateModal()">Cancel</button>
      <button class="btn-confirm" (click)="submitCreateRm()" [disabled]="creating">
        <span *ngIf="!creating"><i class="bi bi-check-lg"></i> Create RM Account</span>
        <span *ngIf="creating"><span class="spinner-border spinner-border-sm"></span> Creating...</span>
      </button>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div class="modal-backdrop-custom" *ngIf="showEditModal && editingRm" (click)="closeEditModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4><i class="bi bi-pencil-square" style="color: var(--color-primary, #B01E3E);"></i> Edit RM Details: {{ editingRm.name }}</h4>
      <button class="btn-close-modal" (click)="closeEditModal()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Full Name</label>
          <input type="text" [(ngModel)]="editingRm.name" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Employee ID</label>
          <input type="text" [(ngModel)]="editingRm.employee_id" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Official Email</label>
          <input type="email" [(ngModel)]="editingRm.email" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Mobile Phone</label>
          <input type="text" [(ngModel)]="editingRm.phone" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Status</label>
          <select [(ngModel)]="editingRm.status" class="form-select">
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="form-label">Maximum Client Capacity</label>
          <input type="number" [(ngModel)]="editingRm.max_client_capacity" class="form-control" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeEditModal()">Cancel</button>
      <button class="btn-confirm" (click)="submitEditRm()">Save Changes</button>
    </div>
  </div>
</div>

<!-- Reassign Modal -->
<div class="modal-backdrop-custom" *ngIf="showReassignModal && selectedSubscriber" (click)="closeReassignModal()">
  <div class="modal-card small-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4><i class="bi bi-arrow-left-right" style="color: var(--color-primary, #B01E3E);"></i> Assign Relationship Manager</h4>
      <button class="btn-close-modal" (click)="closeReassignModal()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="modal-body">
      <p class="mb-3">Assign or switch dedicated Relationship Manager (`RM`) for <strong>{{ selectedSubscriber.name }}</strong> (Plan: {{ selectedSubscriber.current_plan }}):</p>
      <div class="form-group">
        <label class="form-label">Select Active RM</label>
        <select [(ngModel)]="targetRmId" class="form-select">
          <option value="">-- Select RM --</option>
          <option *ngFor="let rm of rms" [value]="rm._id" [disabled]="rm.status !== 'Active' || rm.current_assigned_clients >= rm.max_client_capacity">
            {{ rm.name }} ({{ rm.employee_id }}) — {{ rm.current_assigned_clients }}/{{ rm.max_client_capacity }} Clients [{{ rm.status }}]
          </option>
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeReassignModal()">Cancel</button>
      <button class="btn-confirm" (click)="submitReassign()" [disabled]="!targetRmId || reassigning">
        <span *ngIf="!reassigning"><i class="bi bi-check-lg"></i> Confirm Assignment</span>
        <span *ngIf="reassigning"><span class="spinner-border spinner-border-sm"></span> Assigning...</span>
      </button>
    </div>
  </div>
</div>
